import api, { ResponseCallback } from '../services/api.service'

interface ChartUnitsByLocationResponse {
  locations: string[]
  units: number[]
}

export interface ChartActiveWorkOrdersResponse {
  workOrders: string[]
  produceds: number[]
  remainings: number[]
}

export interface ChartCasesShippedResponse {
  dates: string[]
  cases: number[]
}

const routes = {
  unitsByLocation: '/charts/unitsByLocation',
  activeWorkOrders: '/charts/activeWorkOrders',
  casesShipped: '/charts/casesShipped'
}

export default {
  unitsByLocation (
    location: string,
    item: string,
    callback: ResponseCallback<ChartUnitsByLocationResponse>
  ) {
    const params = { location, item }
    api.get(routes.unitsByLocation, params, callback)
  },
  activeWorkOrders (
    workOrder: string,
    item: string,
    callback: ResponseCallback<ChartActiveWorkOrdersResponse>
  ) {
    const params = { workOrder, item }
    api.get(routes.activeWorkOrders, params, callback)
  },
  casesShipped (
    item: string,
    callback: ResponseCallback<ChartCasesShippedResponse>
  ) {
    const params = { item }
    api.get(routes.casesShipped, params, callback)
  }
}
